import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Body2, Header2, Button, ListSeparator } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import ListOfAllInvoices from "~/components/Subscription/ListOfAllInvoices";
import i18n from "~/i18n";
import { currencySymbols } from "~/utils/currency_symbols";
import FormatDate from "../Formatters/FormatDate.jsx";

const LastInvoice = ({ lastInvoice }) => {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);

  const openDialogWithInvoices = useCallback(() => {
    setOpenDialog(true);
  }, []);

  const closeDialogWithInvoices = useCallback(() => {
    setOpenDialog(false);
  }, []);

  return (
    <div>
      <ListOfAllInvoices
        open={openDialog}
        onClose={closeDialogWithInvoices}
      />
      <>
        <div className="tw-flex tw-justify-between">
          <Header2 color="primary">{t("Last Invoice")}</Header2>
          <Button
            variant="text colored"
            onClick={openDialogWithInvoices}
          >
            {t("View all invoices")}
          </Button>
        </div>
        <ListSeparator className="tw-mx-0 tw-mt-0 tw-mb-6" />
      </>
      <div className="tw-grid tw-grid-cols-[200px_auto] tw-grid-rows-3 tw-gap-2">
        <Body2
          color="primary"
          weight="bold"
        >
          {t("Date")}
        </Body2>
        <Body2
          color="tertiary"
          data-testid="Date"
        >
          <FormatDate value={lastInvoice.issued_on} />
        </Body2>
        <Body2
          color="primary"
          weight="bold"
        >
          {t("Amount")}
        </Body2>
        <Body2
          color="tertiary"
          data-testid="Amount"
        >
          {`${currencySymbols[lastInvoice.currency_code]}${lastInvoice.amount}`}
        </Body2>
        <Body2
          color="primary"
          weight="bold"
        >
          {t("Actions")}
        </Body2>
        <a
          href={lastInvoice.download_url}
          className={classNames("activity-link", {
            is_disabled_link: !lastInvoice.download_url,
          })}
          target="_blank"
          rel="noreferrer"
          data-testid="link-disabled"
        >
          {lastInvoice.download_url ? i18n.t("View Invoice") : "-"}
        </a>
      </div>
    </div>
  );
};

LastInvoice.propTypes = {
  lastInvoice: PropTypes.object,
};

LastInvoice.displayName = `LastInvoice`;

export default LastInvoice;
